export default async function ({ store, redirect }) {
  if (!store.getters["user/IS_BAND"]) return redirect("/")
  await store.dispatch("draft/GET_CURRENT", { clean_hidden_influencers: true })
}
